import ReactGA from 'react-ga'
import { createBrowserHistory } from 'history'

import { GOOGLE_ANALYTICS_KEY } from 'config'
import store from 'store'


ReactGA.initialize(GOOGLE_ANALYTICS_KEY)

const history = createBrowserHistory()
history.listen(location => {
  if (
    GOOGLE_ANALYTICS_KEY !== '' &&
    location.pathname !== '/eportfolio/mine'
  ) {
    setTimeout(() => {
      const auth = store.getState().auth
      if (auth.isLogged) {
        ReactGA.set({userId: auth.user.id})
      }

      ReactGA.set({page: location.pathname})
      ReactGA.pageview(location.pathname)

    }, 0)
  }
})

export const createRGAEvent = (category, action, label='', value=null, nonInteraction=false) => {
  setTimeout(() => ReactGA.event({
    category: category,
    action: action,
  }), 0)
}

export default history
